import { render, staticRenderFns } from "./ReviewChargesOverview.vue?vue&type=template&id=dee98736&scoped=true&"
import script from "./ReviewChargesOverview.vue?vue&type=script&lang=js&"
export * from "./ReviewChargesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewChargesOverview.vue?vue&type=style&index=0&id=dee98736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee98736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dee98736')) {
      api.createRecord('dee98736', component.options)
    } else {
      api.reload('dee98736', component.options)
    }
    module.hot.accept("./ReviewChargesOverview.vue?vue&type=template&id=dee98736&scoped=true&", function () {
      api.rerender('dee98736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/ReviewChargesOverview.vue"
export default component.exports